import SectionHeader from "@/components/SectionHeader";
import useSettings from "@/lib/useSettings";
import { Link } from "react-router-dom";
import { Mail, Bike, ShieldCheck } from "lucide-react";

export default function About() {
  const settings = useSettings();
  const paragraphs = (settings.about_long || "").split(/\n\s*\n/).filter(Boolean);
  return (
    <div className="max-w-5xl mx-auto px-5 py-16" data-testid="about-page">
      <SectionHeader title="O Klubie" />
      <div className="space-y-6 mt-10 text-lg leading-relaxed fade-up" style={{ color: "var(--sr-cream-soft)" }}>
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}

        <h3 className="font-display text-2xl text-[var(--sr-cream)] mt-12 tracking-wider">NASZ KODEKS</h3>
        <ul className="space-y-3 list-none">
          <li className="flex gap-3"><span className="text-[var(--sr-fire)]">◆</span> Brat ponad wszystko — nie zostawiamy nikogo na poboczu.</li>
          <li className="flex gap-3"><span className="text-[var(--sr-fire)]">◆</span> Honor w drodze i poza nią.</li>
          <li className="flex gap-3"><span className="text-[var(--sr-fire)]">◆</span> Szacunek do dziedzictwa i innych klubów.</li>
          <li className="flex gap-3"><span className="text-[var(--sr-fire)]">◆</span> Lojalność wobec barw i braci.</li>
        </ul>

        <p className="mt-10">
          Jeśli czujesz w sobie ten sam płomień — odezwij się. Drzwi klubu są otwarte dla tych, którzy rozumieją,
          że <em>jedna droga, jedna rodzina, jeden klub</em> to nie slogan, lecz styl życia.
        </p>
      </div>

      {/* JAK DOŁĄCZYĆ */}
      <div className="mt-20" data-testid="how-to-join">
        <SectionHeader title="Jak dołączyć?" />
        <p className="text-center mt-6 mb-12" style={{ color: "var(--sr-cream-soft)" }}>
          Droga do klubowych barw to nie sprint — to wybór na lata.
        </p>

        <div className="grid md:grid-cols-2 gap-5">
          <Step n="01" title="Prospect" icon={<Bike />} desc="Pierwszy etap formalny. Jeździsz z klubem, uczysz się tradycji, poznajesz braci na trasie." />
          <Step n="02" title="Member" icon={<ShieldCheck />} desc="Pełnoprawny członek. Nosisz barwy klubu — to honor i odpowiedzialność na całe życie." />
        </div>

        <div className="sr-card p-6 md:p-8 mt-10">
          <h4 className="font-display text-xl text-[var(--sr-fire-2)]">CZEGO OCZEKUJEMY</h4>
          <ul className="mt-4 space-y-2" style={{ color: "var(--sr-cream-soft)" }}>
            {(settings.expectations_list || "")
              .split("\n")
              .map((line) => line.trim())
              .filter(Boolean)
              .map((line, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-[var(--sr-fire)]">◆</span> {line}
                </li>
              ))}
          </ul>
          <Link to="/kontakt" className="inline-flex items-center gap-2 mt-6" data-testid="join-cta">
            <span className="btn-fire">Napisz do nas <Mail size={14} className="inline" /></span>
          </Link>
        </div>
      </div>
    </div>
  );
}

function Step({ n, title, icon, desc }) {
  return (
    <div className="sr-card p-6 fade-up" data-testid={`step-${n}`}>
      <div className="flex items-center justify-between mb-3">
        <span className="font-display text-3xl text-[var(--sr-fire)]">{n}</span>
        <span className="text-[var(--sr-fire)]">{icon}</span>
      </div>
      <h4 className="font-display text-xl text-[var(--sr-cream)] mb-2">{title}</h4>
      <p className="text-sm" style={{ color: "var(--sr-cream-soft)" }}>{desc}</p>
    </div>
  );
}
